import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AIS140TmlApiLogsComponent } from './ais140-tml-api-logs.component';
const routes: Routes = [
  {
    path: 'ais140-tml-api-logs',
    data: { name: 'AIS140 Ticket Status Update Logs', isTab: false },
    component: AIS140TmlApiLogsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AIS140TmlApiLogsRoutingModule {}
